// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "co.arculus",
    name: "Arculus Wallet",
    homepage: "https://www.arculus.co",
    image_id: "f78dab27-7165-4a3d-fdb1-fcff06c0a700",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/arculus-wallet/id1575425801",
        android: "https://play.google.com/store/apps/details?id=co.arculus.wallet.android&hl=en_US&gl=US",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "arculuswc://",
        universal: "https://gw.arculus.co/app",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map